export default "__VITE_ASSET__SUYPWtaA__"